const state = {
    isShow: false,
    src: null
}

const mutations = {
    setState: (state, {key, value}) => {
        state[key] = value;
    }
}

const getters = {
    src: state => state.src,
    isShow: state => state.isShow
}

export default {
    namespaced: true,
    
    state,
    mutations,
    getters
}